import { Chip } from "framework7-react";
import { useMemo, useState } from "react";
import { useToast } from "../../hooks/use-toast";
import { suggestTags } from "../../utils/tag-suggestions";
import {
  MAX_TAGS,
  MAX_TAG_NAME_LENGTH,
  findTag,
  normalizeTagName,
  tagKey,
  uniqueTagNames,
} from "../../utils/tags";
import TagChip from "./tag-chip";

export const TAG_LIMIT_TEXT = `Eine Ausgabe kann höchstens ${MAX_TAGS} Tags haben.`;

const TagPicker = ({ groupTags = [], selected = [], onChange }) => {
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");
  const { showError } = useToast();
  const chips = useMemo(
    () => suggestTags(groupTags, selected),
    [groupTags, selected],
  );

  const isSelected = (name) =>
    selected.some((other) => tagKey(other) === tagKey(name));

  const select = (name) => {
    if (isSelected(name)) return;
    if (uniqueTagNames(selected).length >= MAX_TAGS) {
      showError(TAG_LIMIT_TEXT);
      return;
    }
    onChange([...selected, name]);
  };

  const toggle = (name) => {
    if (isSelected(name)) {
      onChange(selected.filter((other) => tagKey(other) !== tagKey(name)));
    } else {
      select(name);
    }
  };

  const commit = () => {
    const name = normalizeTagName(draft);
    setDraft("");
    setAdding(false);
    if (name) select(findTag(groupTags, name)?.name ?? name);
  };

  return (
    <div className="tag-picker">
      {chips.map((chip) => (
        <TagChip
          key={tagKey(chip.name)}
          name={chip.name}
          color={chip.color}
          selected={chip.selected}
          onClick={() => toggle(chip.name)}
        />
      ))}
      {adding ? (
        <input
          className="tag-name-input"
          name="new-tag"
          type="text"
          autoFocus
          autoComplete="off"
          autoCapitalize="sentences"
          enterKeyHint="done"
          maxLength={MAX_TAG_NAME_LENGTH}
          placeholder="Neuer Tag"
          aria-label="Neuer Tag"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={commit}
          onKeyDown={(event) => {
            if (event.key !== "Enter") return;
            event.preventDefault();
            commit();
          }}
        />
      ) : (
        <Chip
          className="tag-chip tag-chip-add"
          outline
          text="+"
          aria-label="Neuer Tag"
          onClick={() => setAdding(true)}
        />
      )}
    </div>
  );
};

export default TagPicker;
